import { onDomReady } from '@scripts/utils/onDomReady';

function init() {}

onDomReady(() => init());

if (window.acf?.addAction) {
  const rerender = ($el) => init($el[0] || $el); // $el — jQuery, берём нативный dom‑node

  window.acf.addAction('render_block_preview', rerender);
  window.acf.addAction('render_block_preview_complete', rerender);
}
